import DependencyListBuilder from "../../../utility/DependencyListBuilder";

import CalendarEventController from "./CalendarEventController";

const calendarThreeDayEventComponentTemplate = require("./CalendarThreeDayEvent.tpl.html");

const CalendarThreeDayEventComponent = {
    name: "tbCalendarThreeDayEvent",
    config: {
        template: calendarThreeDayEventComponentTemplate,
        bindings: {
            eventData: "=tbEventData",
            editorNavigateFn: "&tbEditorNavigateFn",
            eventSelected: "&tbEventSelected",
            eventTextClass: "@tbEventTextClass"
        },
        controller: CalendarEventController,
        controllerAs: CalendarEventController.controllerAs
    }
};

CalendarThreeDayEventComponent.dependencies = DependencyListBuilder([
    CalendarEventController.dependencies
]);

export default CalendarThreeDayEventComponent;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/calendar-event/CalendarThreeDayEvent.js
// module id = 4m1Z
// module chunks = 1